import { render, staticRenderFns } from "./footBox.vue?vue&type=template&id=10d7df06&scoped=true"
import script from "./footBox.vue?vue&type=script&lang=js"
export * from "./footBox.vue?vue&type=script&lang=js"
import style0 from "./footBox.vue?vue&type=style&index=0&id=10d7df06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d7df06",
  null
  
)

export default component.exports